module.exports = __webpack_public_path__ + "img/agency.4ce42609.svg";